import Spread from "./Spread";
import Yield from "./Yield";
class Pricing {
    issuePrice;
    price;
    spread;
    yield;
    constructor(response) {
        if (response !== undefined) {
            this.issuePrice = response.issuePrice;
            this.price = response.price;
            this.spread = response.spread !== undefined ? new Spread(response.spread) : undefined;
            this.yield = response.yield !== undefined ? new Yield(response.yield) : undefined;
        }
    }
    print(basis) {
        if (basis === 'spread') {
            if (this.spread !== undefined) {
                return this.spread.print().join(" ");
            }
            else {
                if (this.yield?.value !== undefined) {
                    return `[${this.yield.print()}]`;
                }
            }
        }
        else if (basis === 'yield') {
            if (this.yield?.value !== undefined) {
                return this.yield.print();
            }
            else if (this.spread !== undefined) {
                return `[${this.spread.print().join(" ")}]`;
            }
        }
        else {
            if (this.spread !== undefined) {
                return this.spread.print().join(" ");
            }
            else if (this.yield?.value !== undefined) {
                return this.yield.print();
            }
        }
        return undefined;
    }
    printPrice() {
        if (this.price !== undefined) {
            return { value: this.price };
        }
        else if (this.issuePrice !== undefined) {
            return { value: this.issuePrice };
        }
        return undefined;
    }
}
export default Pricing;
